import { AfterViewInit, Component, OnDestroy, Input, OnChanges, ɵɵNgOnChangesFeature, SimpleChanges } from '@angular/core';
import { NbThemeService, NB_THEME_OPTIONS } from '@nebular/theme';
import { ResizedEvent } from 'angular-resize-event';
import { CHART_CONFIG} from '../config/baseconfig.component';
import { Social_Platform,
  Material_Design_Red, 
  Material_Design_Pink, 
  Material_Design_Purple, 
  Material_Design_Deep_Purple } from '../config/color-palettes';
import { DEFAULT_THEME as defaultTheme } from '@nebular/theme';

@Component({
  selector: 'nbx-sankey-echart',
  templateUrl: './sankey.component.html',
  styleUrls: ['./sankey.component.scss']
})
export class SankeyEchartComponent implements AfterViewInit {
  @Input() opts: any = {};
  defaultThemeVariables = defaultTheme.variables; 
  @Input() tooltipstr: string = '';
  @Input() legendstr: string = '';
  @Input() seriesstr: string = '';
  @Input() titlestr: string = '';

  options: any = {};
  title: any;
  tooltip: any;
  legend: any;
  series: any;

  echartsInstance: any;

  @Input() resizable: boolean = true;
  autoResize = true;

  width: number;
  height: number;

  onResized(event: ResizedEvent) {
    this.width = event.newWidth;
    this.height = event.newHeight;

    if (this.echartsInstance)
    {
      this.echartsInstance.resize({
        height: event.newHeight
      });
    }
  }

 
  ngAfterViewInit() {
    //Set Defaults
    this.title = (this.titlestr == '') ? {
      text: '',
      subtext: '',
      left: 'center'
    } : JSON.parse(this.titlestr);  

    this.tooltip = (this.tooltipstr == '') ? {
      trigger: 'item',
    } : JSON.parse(this.tooltipstr);

    this.legend = (this.legendstr == '') ? {
      orient: 'vertical',
      left: 'left',
      data: ['USA', 'Germany', 'France', 'Canada', 'Russia']
    } : JSON.parse(this.legendstr);
    
    this.series = (this.legendstr == '') ? {
      type: 'sankey',
      layout: 'none',
      focusNodeAdjacency: 'allEdges',
      data: [{
          name: 'a'
      }, {
          name: 'b'
      }, {
          name: 'a1'
      }, {
          name: 'a2'
      }, {
          name: 'b1'
      }, {
          name: 'c'
      }],
      links: [{
          source: 'a',
          target: 'a1',
          value: 5
      }, {
          source: 'a',
          target: 'a2',
          value: 3
      }, {
          source: 'b',
          target: 'b1',
          value: 8
      }, {
          source: 'a',
          target: 'b1',
          value: 3
      }, {
          source: 'b1',
          target: 'a1',
          value: 1
      }, {
          source: 'b1',
          target: 'c',
          value: 2
      }]
  } : JSON.parse(this.seriesstr);

    this.options = {
      backgroundColor: 'transparent',
      color: Object.values(Material_Design_Pink),
      grid: {
        width: 800,
        height: 500
      },
      title: this.title,
      tooltip: this.tooltip,
      legend: this.legend,
      series: this.series
    }
   
  }
  ngOnChanges(changes: SimpleChanges) {

    console.log("update");
    console.log(changes);

    for (const propName in changes)
    {
      if (changes.hasOwnProperty(propName))
      {
        switch(propName) {
          case 'tooltipstr': {
            console.log("tooltip update");
              this.updateOptions('tooltip',this.tooltipstr);
            break;     
          }
          case 'legendstr': {
            console.log("legend update");
              this.updateOptions('legend',this.legendstr);
            break;
          }
          case 'seriesstr': {
            console.log("series update");
              this.updateOptions('series',this.seriesstr);
            break;
          }
          case 'titlestr': {
            console.log("title update");
              this.updateOptions('title',this.titlestr);
            break;
          }
        }
      }
    }

    this.options = {
      backgroundColor: 'transparent',
      color: Object.values(Material_Design_Pink),
      title: this.title,
      tooltip: this.tooltip,
      legend: this.legend,
      series: this.series
    }

  }

  onChartInit(e: any) {
    this.echartsInstance = e;
    console.log('on chart init:', e);
  }


  private updateOptions(opt, value) {
    console.log(opt)
    console.log(value)
    this[opt] = JSON.parse(value);
    console.log(this.tooltip);

    this.options[opt] = this[opt];

    console.log(this.options);  
  }

  // ngOnDestroy(): void {
  //   this.themeSubscription.unsubscribe();
  // }
} 